import { H1, H2, H3, H4, Title } from "./heading"
import { LineThroughText, P, Label, I, DivText } from "./text"
import { Span } from "./text-styled"

export { H1, H2, H3, H4, Title, P, Label, LineThroughText, Span, I, DivText }
